// extracted by mini-css-extract-plugin
module.exports = {"imageListPaginationWithDetails":"imageListPaginationWithDetails_3DbHm","displayTotalRow":"displayTotalRow_2vcyx"};